import React, { useContext } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { LoadingButton } from "@mui/lab";
import { ExportContext } from "../../context/ExportProvider";
const ExportVisitorsButton = ({ filter, sourceFilter, sq }) => {
  const { exportVisitors, visitorExporting } = useContext(ExportContext);
  return (
    <>
      <LoadingButton
        onClick={() => exportVisitors(filter, sourceFilter, sq)}
        variant="outlined"
        loading={visitorExporting}
        startIcon={<FileDownloadIcon />}
      >
        Export to Excel
      </LoadingButton>
    </>
  );
};

export default ExportVisitorsButton;
